import { render } from "./PR11-080522.vue?vue&type=template&id=ce2864b4"
import script from "./PR11-080522.vue?vue&type=script&lang=js"
export * from "./PR11-080522.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__